import React, {useRef} from 'react'

const ReferralSection = ({referralLink}) => {
    const inputRef = useRef(null);

    const copyToClipboard = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand('copy');
      navigator.clipboard.writeText(inputRef.current.value).catch(err => {
        console.error('Error al copiar el texto: ', err);
      });
    }
  };

  return (
    <div className="w-full mt-4">
            <div>
              <h2 className="text-center text-upper font-semibold text-sm sm:text-lg">Earn with Referral</h2>
              <span className="text-wrap">Invite your friends and family to join our community, and you'll reap the rewards - 10% of the value of their purchased contributions, paid in BNB or USDT.</span>
            </div>
            <div className="flex flex-col justify-center mt-4">
              <h2 className="text-center text-upper font-semibold text-sm sm:text-lg">Your Referral Link</h2>
              <div className="flex justify-center">
                <input 
                ref={inputRef}
                className="w-[60%] appearance-none block bg-white border border-gray-300 rounded-md py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text" name="your_referral_link" value={referralLink} readOnly />
              <button
              className="ml-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300 transform active:scale-90 focus:outline-none" 
              onClick={copyToClipboard}
              >Copy</button>
              </div>
            </div>
        </div>
  )
}

export default ReferralSection